import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {StatusPage} from "../StatusPage";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {Copy} from "react-bootstrap-icons";

export class SnapshotHistory extends ListComponent {
    protected limit: number = 250;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product/snapshot-history';
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }

        const params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-md-12 sub-details">
                                <div className="row">
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'product_id', defaultValue: params?.product_id}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'snapshot_id', defaultValue: params?.snapshot_id}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'location', defaultValue: params?.location}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Select {...{
                                            id: 'snapshots',
                                            items: ['show-all', 'latest-snapshot'],
                                            defaultValue: params?.snapshots || (params?.snapshot_id ? 'show-all' : 'latest-snapshot')
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.DateTime {...{
                                            id: 'created_from',
                                            defaultValue: params?.created_from
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.DateTime {...{
                                            id: 'created_to',
                                            defaultValue: params?.created_to
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'i.id:d'}/>
                        {this.listOfSearchParams(params)}
                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                {/*<button className="btn btn-sm btn-light"*/}
                                {/*        onClick={((event: MouseEvent | any) => {*/}
                                {/*            event.preventDefault();*/}
                                {/*            this.exportTableData('/product/snapshot-history/export')*/}
                                {/*        })}>*/}
                                {/*    {this.dictionary.get['export']}*/}
                                {/*</button>*/}
                                {/*&nbsp;*/}
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['snapshot-history']}: &nbsp;
                                    <strong>{this.state.count ? <FormattedNumber
                                        value={this.state.count}/> : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-md-3">
                                {this.dictionary.get['available_quantity']}:&nbsp;
                                <strong>
                                    {this.state?.item?.available_quantity ?
                                        <FormattedNumber value={this.state.item.available_quantity}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-md-3">
                                {this.dictionary.get['reserved_quantity']}:&nbsp;
                                <strong>
                                    {this.state?.item?.reserved_quantity ?
                                        <FormattedNumber value={this.state.item.reserved_quantity}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-md-3">
                                SUM:&nbsp;
                                <strong>
                                    {this.state?.item?.sum ? <FormattedNumber value={this.state.item.sum}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-md-3">
                                {this.dictionary.get['unit_cost_all']}:&nbsp;
                                <strong>
                                    {this.state?.item?.unit_cost ?
                                        <FormattedNumber value={this.state.item.unit_cost}/> : '-'}
                                </strong>
                                &nbsp;{'EUR'}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="i.id">
                                    # <i className="bi bi-sort-down-alt"></i>
                                </th>
                                <th className="sortable"
                                    data-sortkey="p.`name`">{this.dictionary.get['product_name']}</th>
                                <th className="sortable" data-sortkey="p.`id`"
                                    colSpan={2}>{this.dictionary.get['product_id']}</th>
                                <th className="sortable" data-sortkey="p.`sku`">{this.dictionary.get['sku']}</th>
                                <th>{this.dictionary.get['type']}</th>
                                <th className="sortable"
                                    data-sortkey="i.`location`">{this.dictionary.get['location']}</th>
                                <th className="sortable"
                                    data-sortkey="i.`available_quantity`">{this.dictionary.get['available_quantity']}</th>
                                <th className="sortable" data-sortkey="i.`reserved_quantity`">
                                    {this.dictionary.get['reserved_quantity']}
                                </th>
                                <th className="sortable" data-sortkey="i.`quantity`">
                                    SUM
                                </th>

                                <th align={"right"} className="sortable"
                                    data-sortkey="p.`unit_cost`">{this.dictionary.get['unit_cost']}</th>
                                <th align={"right"} className="sortable"
                                    data-sortkey="(p.`unit_cost` * i.`quantity`)">{this.dictionary.get['unit_cost_all']}</th>

                                <th className="sortable" data-sortkey="s.created_at">
                                    {this.dictionary.get['created']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                const productLink: string = '/product/details/' + elem.product_id;
                                return (
                                    <tr key={elem.item_id} data-id={elem.item_id}>
                                        {Util.searchCell(elem.id, 'snapshot_id', {style: {textAlign: 'right'}})}
                                        <td>{elem.product_name}</td>
                                        <td onClick={Util.copy} className="copy" data-copy={elem.product_id}
                                            style={{padding: '10px 18px', color: '#3366FF'}}>
                                            <Copy onClick={Util.copy} className="copy" data-copy={elem.product_id}/>
                                        </td>
                                        <td>{Util.link(elem.product_id, productLink)}</td>
                                        {Util.searchCell(elem.sku, 'sku')}
                                        <td>{elem.type}</td>
                                        {Util.searchCell(elem.location, 'location')}
                                        <td>{elem.available_quantity}</td>
                                        <td>{elem.reserved_quantity}</td>
                                        <td>{elem.sum || '-'}</td>
                                        <td align={"right"}>{elem.unit_cost ?
                                            <FormattedNumber value={elem.unit_cost} suffix={"EUR"}/> : '-'}</td>
                                        <td align={"right"}>{elem.unit_cost ?
                                            <FormattedNumber value={elem.unit_cost * elem.sum}
                                                             suffix={"EUR"}/> : '-'}</td>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
